if (!customElements.get("main-product")) {
 class MainProduct extends HTMLElement {
  expandCls = "description--less";
  constructor() {
   super();
   this.btnReadmore = this.querySelector("#btnReadmore");
   this.productContent = this.querySelector("#productContent");
   this.variantAddToCartId = this.querySelector(".product-variant-id");
   this.variant = this.querySelector("variant-selects");
   btnReadmore.addEventListener("click", this.handleRedmoreContent);
  }

  connectedCallback() {
   this.variantIdChangedUnsubscriber = subscribe(
    PUB_SUB_EVENTS.variantChange,
    ({ data }) => {
     this.variantAddToCartId.value = data.variant.id;
     this.updateSubscriptionWidget(data.html);
    }
   );
   this.sellingPlanChangedUnsubscriber = subscribe(
    PUB_SUB_EVENTS.sellingPlanChange,
    ({ data }) => {
     if (data.value) {
      if (this.variant.currentVariant) {
       const selling_plan_allocations =
        this.variant.currentVariant.selling_plan_allocations;
       const selling_plan = selling_plan_allocations.find(
        (f) => f.selling_plan_id == data.value
       );
       if (selling_plan)
        if (selling_plan.compare_at_price != selling_plan.price) {
         this.querySelector(".price-per-item").children[0].textContent =
          Shopify.formatMoney(selling_plan.compare_at_price);

         this.querySelector(".price-per-item").children[1].textContent =
          Shopify.formatMoney(selling_plan.price);
        }
      }
     } else {
      this.querySelector(".price-per-item").children[0].textContent = this
       .variant.currentVariant.compare_at_price
       ? Shopify.formatMoney(this.variant.currentVariant.compare_at_price)
       : "";
      this.querySelector(".price-per-item").children[1].textContent =
       Shopify.formatMoney(this.variant.currentVariant.price);
     }
    }
   );
  }
  disconnectedCallback() {
   if (this.variantIdChangedUnsubscriber) {
    this.variantIdChangedUnsubscriber();
   }
   if (this.sellingPlanChangedUnsubscriber) {
    this.sellingPlanChangedUnsubscriber();
   }
  }
  handleRedmoreContent = () => {
   if (this.productContent.classList.contains(this.expandCls)) {
    this.productContent.classList.remove(this.expandCls);
    this.btnReadmore.innerText = "Read less";
   } else {
    this.productContent.classList.add(this.expandCls);
    this.btnReadmore.innerText = "Read more";
   }
  };

  updateURL() {
   if (!this.currentVariant || this.dataset.updateUrl === "false") return;
   window.history.replaceState(
    {},
    "",
    `${this.data.dataset.url}?variant=${this.currentVariant.id}`
   );
  }

  updateSubscriptionWidget(html) {
   const originalSection = document.getElementById("subscription_widget"),
    htmlSection = html.getElementById("subscription_widget");
   originalSection.innerHTML = htmlSection.innerHTML;
  }
 }

 if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
 }

 class VariantSelects extends HTMLElement {
  constructor() {
   super();
   this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
   this.updateOptions();
   this.updateMasterId();
  }

  onVariantChange() {
   this.updateOptions();
   this.updateMasterId();
   this.toggleAddButton(true, "", false);
   this.updatePickupAvailability();
   this.removeErrorMessage();
   this.updateVariantStatuses();

   if (!this.currentVariant) {
    this.toggleAddButton(true, "", true);
    this.setUnavailable();
   } else {
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
   }
  }

  updateOptions() {
   this.options = Array.from(
    this.querySelectorAll("select"),
    (select) => select.value
   );
  }

  updateMasterId() {
   this.variantData =
    this.variantData ||
    JSON.parse(this.querySelector('[type="application/json"]').textContent);
   this.currentVariant = this.variantData.find((variant) => {
    return !variant.options
     .map((option, index) => {
      return this.options[index] === option;
     })
     .includes(false);
   });
   this.dispatchEvent(
    new CustomEvent("variantChange", { variant: this.currentVariant })
   );
  }

  updateMedia() {
   if (!this.currentVariant) return;
   if (!this.currentVariant.featured_media) return;

   const mediaGalleries = document.querySelectorAll(
    `[id^="MediaGallery-${this.dataset.section}"]`
   );
   mediaGalleries.forEach((mediaGallery) =>
    mediaGallery.setActiveMedia(
     `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
     true
    )
   );

   const modalContent = document.querySelector(
    `#ProductModal-${this.dataset.section} .product-media-modal__content`
   );
   if (!modalContent) return;
   const newMediaModal = modalContent.querySelector(
    `[data-media-id="${this.currentVariant.featured_media.id}"]`
   );
   modalContent.prepend(newMediaModal);
  }

  updateURL() {
   if (!this.currentVariant || this.dataset.updateUrl === "false") return;
   window.history.replaceState(
    {},
    "",
    `${this.dataset.url}?variant=${this.currentVariant.id}`
   );
  }

  updateShareUrl() {
   const shareButton = document.getElementById(`Share-${this.dataset.section}`);
   if (!shareButton || !shareButton.updateUrl) return;
   shareButton.updateUrl(
    `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
   );
  }

  updateVariantInput() {
   const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
   );
   productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
   });
  }

  updateVariantStatuses() {
   const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(":checked").value === variant.option1
   );
   const inputWrappers = [...this.querySelectorAll(".product-form__input")];
   inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
     ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
     inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
     .filter(
      (variant) =>
       variant.available && variant[`option${index}`] === previousOptionSelected
     )
     .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
   });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
   listOfOptions.forEach((input) => {
    if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
     input.innerText = input.getAttribute("value");
    } else {
     input.innerText = window.variantStrings.unavailable_with_option.replace(
      "[value]",
      input.getAttribute("value")
     );
    }
   });
  }

  updatePickupAvailability() {
   const pickUpAvailability = document.querySelector("pickup-availability");
   if (!pickUpAvailability) return;

   if (this.currentVariant && this.currentVariant.available) {
    pickUpAvailability.fetchAvailability(this.currentVariant.id);
   } else {
    pickUpAvailability.removeAttribute("available");
    pickUpAvailability.innerHTML = "";
   }
  }

  removeErrorMessage() {
   const section = this.closest("section");
   if (!section) return;

   const productForm = section.querySelector("product-form");
   if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
   const requestedVariantId = this.currentVariant.id;
   const sectionId = this.dataset.originalSection
    ? this.dataset.originalSection
    : this.dataset.section;

   fetch(
    `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
     this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section
    }`
   )
    .then((response) => response.text())
    .then((responseText) => {
     // prevent unnecessary ui changes from abandoned selections
     if (this.currentVariant.id !== requestedVariantId) return;

     const html = new DOMParser().parseFromString(responseText, "text/html");
     const destination = document.getElementById(
      `price-${this.dataset.section}`
     );
     const source = html.getElementById(
      `price-${
       this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
     );
     const skuSource = html.getElementById(
      `Sku-${
       this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
     );
     const skuDestination = document.getElementById(
      `Sku-${this.dataset.section}`
     );
     const inventorySource = html.getElementById(
      `Inventory-${
       this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
     );
     const inventoryDestination = document.getElementById(
      `Inventory-${this.dataset.section}`
     );

     const volumePricingSource = html.getElementById(
      `Volume-${
       this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
     );

     const pricePerItemDestination = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
     );
     const pricePerItemSource = html.getElementById(
      `Price-Per-Item-${
       this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
     );

     const volumePricingDestination = document.getElementById(
      `Volume-${this.dataset.section}`
     );
     const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
     );
     const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
     );

     if (volumeNote) volumeNote.classList.remove("hidden");
     if (volumePricingDestination)
      volumePricingDestination.classList.remove("hidden");
     if (qtyRules) qtyRules.classList.remove("hidden");

     if (source && destination) destination.innerHTML = source.innerHTML;
     if (inventorySource && inventoryDestination)
      inventoryDestination.innerHTML = inventorySource.innerHTML;
     if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
       "hidden",
       skuSource.classList.contains("hidden")
      );
     }

     if (volumePricingSource && volumePricingDestination) {
      volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
     }

     if (pricePerItemSource && pricePerItemDestination) {
      pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
      pricePerItemDestination.classList.toggle(
       "hidden",
       pricePerItemSource.classList.contains("hidden")
      );
     }

     const price = document.getElementById(`price-${this.dataset.section}`);

     if (price) price.classList.remove("hidden");

     if (inventoryDestination)
      inventoryDestination.classList.toggle(
       "hidden",
       inventorySource.innerText === ""
      );

     const addButtonUpdated = html.getElementById(
      `ProductSubmitButton-${sectionId}`
     );
     this.toggleAddButton(
      addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
      window.variantStrings.soldOut
     );

     // update subscription widget

     publish(PUB_SUB_EVENTS.variantChange, {
      data: {
       sectionId,
       html,
       variant: this.currentVariant,
      },
     });
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
   const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
   );
   if (!productForm) return;
   const addButton = productForm.querySelector('[name="add"]');
   const addButtonText = addButton.querySelector('[name="button_text"]');
   if (!addButton) return;

   if (disable) {
    addButton.setAttribute("disabled", "disabled");
    if (text && addButtonText) addButtonText.textContent = text;
   } else {
    addButton.removeAttribute("disabled");
    if (addButtonText)
     addButtonText.textContent = window.variantStrings.addToCart;
   }

   if (!modifyClass) return;
  }

  setUnavailable() {
   const button = document.getElementById(
    `product-form-${this.dataset.section}`
   );
   if (!button) return;
   const addButton = button.querySelector('[name="add"]');
   const addButtonText = button.querySelector('[name="add"] > span');
   const price = document.getElementById(`price-${this.dataset.section}`);
   const inventory = document.getElementById(
    `Inventory-${this.dataset.section}`
   );
   const sku = document.getElementById(`Sku-${this.dataset.section}`);
   const pricePerItem = document.getElementById(
    `Price-Per-Item-${this.dataset.section}`
   );
   const volumeNote = document.getElementById(
    `Volume-Note-${this.dataset.section}`
   );
   const volumeTable = document.getElementById(
    `Volume-${this.dataset.section}`
   );
   const qtyRules = document.getElementById(
    `Quantity-Rules-${this.dataset.section}`
   );

   if (!addButton) return;
   addButtonText.textContent = window.variantStrings.unavailable;
   if (price) price.classList.add("hidden");
   if (inventory) inventory.classList.add("hidden");
   if (sku) sku.classList.add("hidden");
   if (pricePerItem) pricePerItem.classList.add("hidden");
   if (volumeNote) volumeNote.classList.add("hidden");
   if (volumeTable) volumeTable.classList.add("hidden");
   if (qtyRules) qtyRules.classList.add("hidden");
  }
 }

 customElements.define("variant-selects", VariantSelects);

 class ProductRecommendation extends HTMLElement {
  constructor() {
   super();
   this.priceText = this.querySelector("[price]");
   this.salePriceText = this.querySelector("[salePrice]");
   this.variantAddToCartId = this.querySelector(".product-variant-id");
  }

  connectedCallback() {
   this.addEventListener("change", this.onVariantChange);
  }

  disconnectedCallback() {
   this.removeEventListener("change", this.onVariantChange);
  }
  updateOptions() {
   this.options = Array.from(
    this.querySelectorAll("select"),
    (select) => select.value
   );
  }
  loadData() {
   this.variantData =
    this.variantData ||
    JSON.parse(this.querySelector('[type="application/json"]').textContent);
   this.currentVariant = this.variantData.find((variant) => {
    return !variant.options
     .map((option, index) => {
      return this.options[index] === option;
     })
     .includes(false);
   });
  }

  onVariantChange = () => {
   this.updateOptions();
   this.loadData();
   if (this.currentVariant) {
    let price,
     salePrice = this.currentVariant.price;
    if (this.currentVariant.compare_at_price) {
     salePrice = this.currentVariant.compare_at_price;
     price = this.currentVariant.price;
    }
    this.priceText.innerText = price ? Shopify.formatMoney(price) : "";
    this.salePriceText.innerText = Shopify.formatMoney(salePrice);
   }
   this.variantAddToCartId.value = this.currentVariant?.id;
  };
 }
 customElements.define("product-recommendation", ProductRecommendation);
}

class SellingPlan extends HTMLElement {
 constructor() {
  super();
  this.addEventListener("change", this.onPlanChange);
 }

 onPlanChange(e) {
  publish(PUB_SUB_EVENTS.sellingPlanChange, {
   data: {
    value: e.target.value,
   },
  });
 }
}

customElements.define("selling-plan", SellingPlan);
